import React from 'react';
import { Button, ButtonProps, OverlayTrigger, Tooltip } from 'react-bootstrap';
import BoldButton from '../Common/BoldButton';

export const permissionDeniedMessage = 'You do not have access to this action.';

type Props = ButtonProps & { allowed: boolean };

const GatedButton = ({ allowed, ...buttonProps }: Props) => {
  if (allowed) return <BoldButton {...buttonProps} />;

  return (
    <OverlayTrigger
      placement="top"
      overlay={overlayProps => <Tooltip {...overlayProps}>{permissionDeniedMessage}</Tooltip>}>
      <Button
        {...buttonProps}
        variant="link"
        disabled={false}
        aria-disabled
        className={`${buttonProps.className ?? ''} fw-bold disabled pe-auto`}
        onClick={event => event.preventDefault()} />
    </OverlayTrigger>
  );
};

export default GatedButton;
